import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Default from '@/masters/Default'
import Client from '@/masters/Client'

import Index from '@/pages/Index'
import Kosik from '@/pages/Kosik'
import Dashboard from '@/pages/Dashboard'
import MujUcet from '@/pages/MujUcet'
import DetailProduktu from '@/pages/DetailProduktu'
import JednorazoveNakupy from '@/pages/JednorazoveNakupy'
import PostupneNakupy from '@/pages/PostupneNakupy'
import MojeZbozi from '@/pages/MojeZbozi'
import MojeFaktury from '@/pages/MojeFaktury'
import Penezenka from '@/pages/Penezenka'
import Klienti from '@/pages/Klienti'
import KlientiDetail from '@/pages/KlientiDetail'
import Spolupracovnici from '@/pages/Spolupracovnici'
import Nadrizeni from '@/pages/Nadrizeni'
import ObchodyProvize from '@/pages/ObchodyProvize'
import ObchodyProvizeDetail from '@/pages/ObchodyProvizeDetail'
import Pozice from '@/pages/Pozice'
import Udalosti from '@/pages/Udalosti'
import KeStazeni from '@/pages/KeStazeni'
import Kontakty from '@/pages/Kontakty'

import KlientIndex from '@/pages/Klient/KlientIndex'
import KlientUdaje from '@/pages/Klient/KlientUdaje'
import KlientZbozi from '@/pages/Klient/KlientZbozi'
import KlientFaktury from '@/pages/Klient/KlientFaktury'
import KlientPenezenka from '@/pages/Klient/KlientPenezenka'

export default new Router({
  routes: [
    {
      path: "/klientska-zona/:id",
      name: "Client",
      component: Client,
      props: (route) => ({ klient: route.params.id }),
      children: [
        {
          path: "ucet-klienta",
          name: "KlientUdaje",
          component: KlientUdaje,
          props: (route) => ({ klient: route.params.id })
        },
        {
          path: "zbozi",
          name: "KlientZbozi",
          component: KlientZbozi,
          props: (route) => ({ klient: route.params.id })
        },
        {
          path: "faktury",
          name: "KlientFaktury",
          component: KlientFaktury,
          props: (route) => ({ klient: route.params.id })
        },
        {
          path: "penezenka",
          name: "KlientPenezenka",
          component: KlientPenezenka,
          props: (route) => ({ klient: route.params.id })
        },
        {
          path: "",
          name: "KlientIndex",
          component: KlientIndex,
          props: (route) => ({ klient: route.params.id })
        },
        {
          path: "/",
          name: "KlientIndex",
          component: KlientIndex,
          props: (route) => ({ klient: route.params.id })
        }
      ]
    },
    {
      path: "/",
      name: "Default",
      component: Default,
      children: [
        {
          path: '/obnova-hesla',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/eshop',
          name: 'Index',
          component: Index
        },
        {
          path: '/kosik',
          name: 'Kosik',
          component: Kosik
        },
        {
          path: '/',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '/muj-ucet',
          name: 'MujUcet',
          component: MujUcet
        },
        {
          path: '/produkty/:id',
          name: 'DetailProduktu',
          component: DetailProduktu,
          props: (route) => ({ id: route.params.id })
        },
        {
          path: '/jednorazove-nakupy',
          name: 'JednorazoveNakupy',
          component: JednorazoveNakupy
        },
        {
          path: '/jednorazove-nakupy/:id',
          name: 'JednorazoveNakupyDetail',
          component: JednorazoveNakupy,
          props: (route) => ({ id: route.params.id })
        },
        {
          path: '/postupne-nakupy',
          name: 'PostupneNakupy',
          component: PostupneNakupy
        },
        {
          path: '/moje-zbozi',
          name: 'MojeZbozi',
          component: MojeZbozi
        },
        {
          path: '/moje-faktury',
          name: 'MojeFaktury',
          component: MojeFaktury
        },
        {
          path: '/penezenka',
          name: 'Penezenka',
          component: Penezenka
        },
        {
          path: '/penezenka/:identifikator',
          name: 'Penezenka',
          component: Penezenka,
          props: (route) => ({ identifikator: route.params.identifikator })
        },
        {
          path: '/klienti',
          name: 'Klienti',
          component: Klienti
        },
        {
          path: '/klienti-detail',
          name: 'KlientiDetail',
          component: KlientiDetail
        },
        {
          path: '/spolupracovnici',
          name: 'Spolupracovnici',
          component: Spolupracovnici
        },
        {
          path: '/obchody-a-provize',
          name: 'ObchodyProvize',
          component: ObchodyProvize
        },
        {
          path: '/obchody-a-provize/:rok/:mesic',
          name: 'ObchodyProvizeDetail',
          component: ObchodyProvizeDetail,
          props: (route) => ({ rok: route.params.rok, mesic: route.params.mesic })
        },
        {
          path: '/pozice',
          name: 'Pozice',
          component: Pozice
        },
        {
          path: '/nadrizeni-pracovnici',
          name: 'Nadrizeni',
          component: Nadrizeni
        },
        {
          path: '/udalosti',
          name: 'Udalosti',
          component: Udalosti
        },
        {
          path: '/ke-stazeni',
          name: 'KeStazeni',
          component: KeStazeni
        },
        {
          path: '/kontakty',
          name: 'Kontakty',
          component: Kontakty
        }
      ]
    },
    {
      path: "/testovaci-klient",
      name: "TestDefault",
      component: Default,
      children: [
        {
          path: 'eshop',
          name: 'TestIndex',
          component: Index
        },
        {
          path: 'kosik',
          name: 'TestKosik',
          component: Kosik
        },
        {
          path: '',
          name: 'TestDashboard',
          component: Dashboard
        },
        {
          path: 'muj-ucet',
          name: 'TestMujUcet',
          component: MujUcet
        },
        {
          path: 'produkty/:id',
          name: 'TestDetailProduktu',
          component: DetailProduktu,
          props: (route) => ({ id: route.params.id })
        },
        {
          path: 'jednorazove-nakupy',
          name: 'TestJednorazoveNakupy',
          component: JednorazoveNakupy
        },
        {
          path: 'jednorazove-nakupy/:id',
          name: 'TestJednorazoveNakupyDetail',
          component: JednorazoveNakupy,
          props: (route) => ({ id: route.params.id })
        },
        {
          path: 'postupne-nakupy',
          name: 'TestPostupneNakupy',
          component: PostupneNakupy
        },
        {
          path: 'moje-zbozi',
          name: 'TestMojeZbozi',
          component: MojeZbozi
        },
        {
          path: 'moje-faktury',
          name: 'TestMojeFaktury',
          component: MojeFaktury
        },
        {
          path: 'penezenka',
          name: 'TestPenezenka',
          component: Penezenka
        },
        {
          path: 'penezenka/:identifikator',
          name: 'TestPenezenka',
          component: Penezenka,
          props: (route) => ({ identifikator: route.params.identifikator })
        },
        {
          path: 'udalosti',
          name: 'TestUdalosti',
          component: Udalosti
        },
        {
          path: 'ke-stazeni',
          name: 'TestKeStazeni',
          component: KeStazeni
        },
        {
          path: 'kontakty',
          name: 'TestKontakty',
          component: Kontakty
        }
      ]
    },
    {
      path: "/",
      name: "Error",
      component: Default,
      children: [
        {
          path: '*',
          name: 'ErrorDashboard',
          component: Dashboard
        },
      ]
    }
  ]
})
